




import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class BadgeLabel extends Vue {
  @Prop({ type: String, required: true }) private text!: string;
  @Prop({ type: String, required: false }) private color!: string;
}
